export default class senderSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/partials/sender-settings.html'),
            controller: SenderCtrl,
            controllerAs: 'senderCtrl'
        }
    }
};

class SenderCtrl {
    constructor($scope, $filter, Account, Customization, Setting, Rest, Events, SweetAlert, SenderDetailsValidator) {
        this._scope = $scope;
        this._translator = $filter('translate');
        this.languageLabels = {
            1: 'GLOBAL:ENGLISH',
            111: 'GLOBAL:SWEDISH'
        };

        this.accountRepo = Account;
        this.customRepo = Customization;
        this.settingsRepo = Setting;
        this.rest = Rest.rest;
        this.eventHandler = Events;
        this.alerter = SweetAlert;
        this.validator = SenderDetailsValidator;

        this.groups = [];
        this.showAdvanced = false;
        this.showSenderSettings = true;
        this.showIntegrations = true;
        this.showIncoming = true;
        this.loading = true;
        this.sitooCredentials = [];
        this.showSitooCredentialsOverlay = false;
        this.loadingSitooCredentials = true;

        this.accountRepo.me().then((account) => {
            this.account = account.data;
        });

        this.customRepo.allGroups().then((groups) => {
            angular.forEach(groups.data, (group) => {
                angular.forEach(group.fields, (field) => {
                    if (field.type == 'text') {
                        this.groups.push({
                            groupName: group.name,
                            groupId: group.id,
                            fieldName: field.name,
                            fieldId: field.id
                        });
                    }
                });
            });
        });


        this.settingsRepo.findSenderDetail().then((details) => {
            details = this.rest.stripRestangular(details);
            details.triggerbee_tracking = details.triggerbee_tracking == 1;
            this.sender = details;

            if (details.custom_fields) {
                this.sender.custom_fields = details.custom_fields;
                this._scope.$broadcast('sender:hasCustomFields', details.custom_fields);
            }

            this.loading = false;
        });

        this.settingsRepo.getSitooCredentials().then((response) => {
            this.sitooCredentials = response.data;
            this.loadingSitooCredentials = false;
        });

        this._scope.$on('sender:customFields:update', (event, customFields) => {
            this.sender.custom_fields = customFields;
            this.updateSenderDetail();
        });

        this._scope.$on('sender:incomingStructure:update', () => {this.updateSenderDetail()});

        $scope.$on('setting:newSitooCredentials', () => {
            this.settingsRepo.getSitooCredentials().then((response) => {
                this.sitooCredentials = response.data;
            });
        });
    }

    toggleSenderSettings() {
        this.showSenderSettings = ! this.showSenderSettings;
    };

    toggleIncoming() {
        this.showIncoming = ! this.showIncoming;
    };

    toggleIntegration() {
        this.showIntegrations = ! this.showIntegrations;
    };

    addCustomIdentifier(item) {
        this.accountRepo.registerCustomIdentifier(item.fieldId).then(() => {
            this.account.custom_identifier = { group_id: item.groupId, field_id: item.fieldId };
            this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:CUSTOM_IDENTIFIER_REGISTERED'));
        });
    };

    customIdentifierAsReadable() {
        let customIdentifier = this.account.custom_identifier, name = '';

        angular.forEach(this.groups, (group) => {
            if (customIdentifier.group_id == group.groupId && customIdentifier.field_id == group.fieldId) {
                name =  group.groupName + '.' + group.fieldName;
            }
        });

        return name;
    };

    clearCustomIdentifier() {
        this.alerter.swal({
            title: this._translator('GLOBAL:FLASH:DELETE'),
            text: this._translator('SETTING:FLASH:CLEAR_CUSTOM_IDENTIFIER_BODY'),
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO'),
            type: 'warning'
        }, (isConfirm) => {
            if (isConfirm) {
                this.accountRepo.clearCustomIdentifier().then(() => {
                    this.account.custom_identifier = null;
                    this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:CUSTOM_IDENTIFIER_CLEARED'));
                });
            }
        });
    };

    updateSenderDetail() {
        if (! this.validator.validate(this.sender)) {
            angular.forEach(this.validator.errors, (errorTranslation) => {
                this.eventHandler.flashEvent('error', this._translator(errorTranslation));
            });

            return;
        }

        this.settingsRepo.updateSenderDetail(this.sender).then(() => {
            this.sender.triggerbee_tracking = this.sender.triggerbee_tracking == 1;

            this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:UPDATE'));
        }, (error) => {
            if (error.status == 400) {
                if (error.data.message == "Invalid URL given.") {
                    this.eventHandler.flashEvent('error', this._translator('SETTING:ERROR:INVALID_UNSUBSCRIPTION_URL'));
                } else if(error.data.email) {
                    this.eventHandler.flashEvent('error', this._translator('SETTING:ERRORS:EMAIL'));
                } else if(error.data.text_message_sender_name) {
                    this.eventHandler.flashEvent('error', this._translator('SETTING:ERRORS:SENDER_NAME'));
                }
            } else {
                return this.eventHandler.flashEvent('error', this._translator('GLOBAL:ERROR:DEFAULT'));
            }
        })
    };

    toggleAdvanced() {
        this.showAdvanced = ! this.showAdvanced;
    };

    toggleSitooCredentialsOverlay() {
        this.showSitooCredentialsOverlay = ! this.showSitooCredentialsOverlay;
    };

    deleteSitooCredentials(id) {
        this.alerter.swal({
            title: this._translator('GLOBAL:DELETE'),
            text: this._translator('SITOO:CONFIRMATION'),
            showCancelButton: true,
            confirmButtonText: this._translator('GLOBAL:YES'),
            cancelButtonText: this._translator('GLOBAL:NO'),
            type: 'warning'
        }, (isConfirm) => {
            if (isConfirm) {
                this.settingsRepo.deleteSitooCredentials(id).then(() => {
                    this.sitooCredentials = this.sitooCredentials.filter((credential) => credential.id !== id);

                    this.eventHandler.flashEvent('notification', this._translator('SITOO:DELETED'));
                }, (error) => {
                    this.eventHandler.flashEvent('error', 'Error');
                });
            }
        });
    };

    getUnsubscribeMessageLabel(languageId) {
        return this._translator('SETTING:TEXT_MESSAGE:UNSUBSCRIBE_LINK:LABEL').replace('[%language%]', this._translator(this.languageLabels[languageId]))
    }

    getUnsubscribeLinkExample(message) {
        return this._translator('SETTING:TEXT_MESSAGE:UNSUBSCRIBE_LINK:EXAMPLE').replace('[%message%]', message)
    }
}
